<div mat-dialog-title class="mat-dialog-title">
  <h3 class="nsc-title" id="{{data.id}}Title"> {{ data.title }}</h3>
  <button mat-dialog-close class="close" aria-label="Close">
    <mat-icon class="nsc-icon__svg" svgIcon="close"></mat-icon>
  </button>
</div>
<mat-dialog-content class="mat-typography">
  <p id="{{data.id}}Content">{{data.body}}</p>
</mat-dialog-content>
<mat-dialog-actions align="start">
  @if (!data.hideYesBtn) {
    <button mat-raised-button color="primary" id="btn-yes" class="nsc-button" type="button" (click)="dialogRef.close(true)">{{ data.btnYesName }}</button>
  }
  @if (!data.hideNoBtn) {
    <button mat-stroked-button color="primary" id="btn-no" class="nsc-button" type="button" (click)="dialogRef.close(false)">{{ data.btnNoName }}</button>
  }
</mat-dialog-actions>

